<p>En esta sección usted podrá subir fotografías o noticias de cada etapa de la aplicación del Modelo de Gestión de Calidad de la Eduación Parvularia (Capacitación, Autoevaluación, Validación y Plan de mejoramiento).</p>
<br>
<div class="diario-mural">
  <div class="diario-mural-contenido">
    <div class="cardNote" *ngFor="let mural of listMural">
      <div style="padding: 20px;">
        <h5>{{mural.idEtapa}}</h5>
        <p>{{mural.texto}}</p>
      </div>      
    </div>
  </div>
  

  <button class="btn-guardar" mat-raised-button (click)="openDialog()">
    <span class="material-icons">cloud_upload</span>
    Añada aquí sus fotos y noticias
  </button>   
</div>
 

 

